/*
 * CardsByBeard — mega-menu gedrag (desktop)
 * - Muis: openen bij hover (kleine vertraging), sluiten bij verlaten; klikken op het hoofditem → pagina van dat item
 * - Toetsenbord/touch: gewoon openen/sluiten met Enter of tik (Dawn's <details>)
 * - "Populair": bestsellers pas ophalen bij hover/openen (sections/cb-mega-feed.liquid)
 */
(function () {
  var hoverMQ = window.matchMedia('(hover: hover) and (pointer: fine)');
  var menus = Array.prototype.slice.call(document.querySelectorAll('details[data-cb-mega]'));
  if (!menus.length) return;

  function loadFeed(details) {
    var box = details.querySelector('[data-cb-mega-feed]');
    if (!box || box.dataset.loaded) return;
    box.dataset.loaded = '1';
    fetch(box.getAttribute('data-cb-mega-feed'))
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelector('[data-cb-mega-items]');
        var target = box.querySelector('[data-cb-mega-target]');
        if (items && items.children.length && target) {
          target.innerHTML = items.innerHTML;
        } else {
          box.hidden = true;
        }
      })
      .catch(function () {
        delete box.dataset.loaded;
      });
  }

  function setOpen(details, open) {
    var summary = details.querySelector('summary');
    if (open) {
      details.setAttribute('open', '');
    } else {
      details.removeAttribute('open');
    }
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  menus.forEach(function (details) {
    var summary = details.querySelector('summary');
    var item = details.closest('li') || details;
    var openTimer;
    var closeTimer;

    details.addEventListener('toggle', function () {
      if (details.open) loadFeed(details);
    });

    item.addEventListener('mouseenter', function () {
      if (!hoverMQ.matches) return;
      loadFeed(details);
      clearTimeout(closeTimer);
      openTimer = setTimeout(function () {
        menus.forEach(function (other) {
          if (other !== details && other.open) setOpen(other, false);
        });
        if (!details.open) setOpen(details, true);
      }, 90);
    });

    item.addEventListener('mouseleave', function () {
      if (!hoverMQ.matches) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () {
        setOpen(details, false);
      }, 200);
    });

    // Muisklik op het hoofditem → naar de pagina (toetsenbord-"klik" heeft detail 0 en opent/sluit gewoon)
    if (summary) {
      summary.addEventListener('click', function (event) {
        var href = summary.getAttribute('data-href');
        if (!hoverMQ.matches || !href || event.detail === 0) return;
        event.preventDefault();
        window.location.href = href;
      });
    }
  });

  // Escape sluit een open menu
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    menus.forEach(function (details) {
      if (details.open) {
        setOpen(details, false);
        var summary = details.querySelector('summary');
        if (summary) summary.focus();
      }
    });
  });
})();
